<template>
  <div class="">
    <b-modal v-model="show" :title="mode === 'edit' ? 'Edit Wps Request' : 'Create Wps Request'" hide-footer @hide="onHide">
      <b-form @submit.prevent="onSubmit">
        <b-form-group label="Select Company">
          <el-select
            v-model="form.company_id"
            :loading="loading.company"
            placeholder="Select Company"
            class="w-full"
            filterable
            remote
            reserve-keyword
            :remote-method="searchCompany"
            @change="handlerChangeCompany"
          >
            <el-option v-for="item in companies.rows" :key="item.company_id" :label="item.company_name" :value="item.company_id">
            </el-option>
          </el-select>
        </b-form-group>
        <b-form-group label="Select Company Client">
          <el-select
            v-model="form.id"
            placeholder="Select Company Client"
            class="w-full"
            :disabled="!form.company_id"
            :loading="loading.companyClient"
            filterable
            @change="handleCompanyClientChange"
          >
            <el-option v-for="item in company_client.rows" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </b-form-group>
        <b-form-group label="Payroll Date">
          <el-date-picker
            :picker-options="datePickerStartOptions"
            class="w-full"
            v-model="form.payroll_date"
            type="date"
            placeholder="Pick Payroll Date"
            format="dd MMMM yyyy"
            value-format="yyyy-MM-dd"
          />
        </b-form-group>
        <b-form-group label="Period">
          <div class="d-flex">
            <el-select size="small" class="mr-2" v-model="form.period_month" placeholder="Select month" style="width: 50%">
              <el-option v-for="option in options" :value="option" :label="option" :key="option"> </el-option>
            </el-select>
            <el-select size="small" v-model="form.period_year" placeholder="Select year" style="width: 50%">
              <el-option v-for="option in year_options" :value="option.value" :label="option.label" :key="option.value">
              </el-option>
            </el-select>
          </div>
        </b-form-group>

        <b-form-group label="Notes">
          <b-textarea v-model="form.notes" placeholder="Input notes" />
        </b-form-group>
        <b-form-group label="Recipient from">
          <el-select
            @change="recipientFromHandler"
            class="mb-2 w-100"
            v-model="recipient_from"
            placeholder="Select recipient input source"
          >
            <el-option label="File" value="file"></el-option>
            <el-option label="Select All from Existing User" value="existing_user"></el-option>
          </el-select>
        </b-form-group>
        <b-form-group label="Total Users" v-if="recipient_from === 'existing_user'">
          <el-input :value="total_rows" :disabled="true" />
          <small class="text-muted d-block mt-1">
            All active employee data from this company client will be used when submitting WPS.
          </small>
          <div class="mt-2">
            <div>Total salary: {{ formatCurrency(existingUserSummary.totalSalary) }}</div>
            <div v-if="companyPolicy.max_balance_disbursement">
              Limit disbursement: {{ formatCurrency(companyPolicy.max_balance_disbursement) }}
            </div>
            <div
              v-if="
                companyPolicy.max_balance_disbursement > 0 &&
                existingUserSummary.totalSalary > companyPolicy.max_balance_disbursement
              "
              class="text-danger mt-1"
            >
              Total nominal disbursement melebihi batas kebijakan perusahaan.
            </div>
          </div>
        </b-form-group>
        <b-form-group label="Recipient File" v-if="recipient_from === 'file'">
          <b-form-file
            v-model="form.csv"
            @change="onChangeFile"
            accept=".csv"
            class="border-1 p-2"
            ref="fileInput"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
          <div class="w-full flex flex-row justify-content-between">
            <span>*only .csv file allowed</span>
            <a href="/sample/csv_wps.csv" download><font-awesome-icon icon="download" /> Download example file</a>
          </div>
          <div class="mt-2">
            <el-button
              size="small"
              type="warning"
              :loading="loading.validate"
              :disabled="recipient_from !== 'file' || !form.csv"
              @click="validateCsvFormat"
            >
              Validate Format
            </el-button>
          </div>
          <div v-if="csvValidation.checked" class="mt-2">
            <div :class="csvValidation.isValid ? 'text-success' : 'text-danger'">
              {{ csvValidation.message }}
            </div>
            <div v-if="csvSummary.totalRows" class="mt-1">
              <div>Total rows: {{ csvSummary.totalRows }}</div>
              <div>Total salary: {{ formatCurrency(csvSummary.totalSalary) }}</div>
              <div v-if="companyPolicy.max_balance_disbursement">
                Limit disbursement: {{ formatCurrency(companyPolicy.max_balance_disbursement) }}
              </div>
            </div>
            <div v-if="csvValidation.errors.length" class="mt-1">
              <div v-for="(error, index) in csvValidation.errors" :key="`${error.row}-${index}`" class="text-danger">
                Row {{ error.row }}: {{ error.message }}
              </div>
            </div>
          </div>
        </b-form-group>
      </b-form>
      <div class="d-flex float-right">
        <el-button
          :loading="loading.submit"
          :disabled="isSubmitDisabled"
          class="mr-2 ml-2"
          size="small"
          type="primary"
          @click="onSubmit"
        >
          Submit
        </el-button>
        <el-button @click="onHide" size="small" class="mr-2">Cancel</el-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { GET_COMPANIES } from "@/store/modules/companies";
import popupErrorMessages from "@/library/popup-error-messages";
import moment from "moment";
import {
  GET_COMPANY_CLIENTS_BY_VENDOR,
  GET_COMPANY_CLIENT_SETTINGS,
  GET_COMPANY_CLIENT_EMPLOYEE_LIST,
} from "../../../store/modules/company_clients";
import { CREATE_WPS, UPDATE_WPS } from "../../../store/modules/wps";

const createInitialForm = () => ({
  id: null,
  period_month: moment().format("MM"),
  period_year: moment().format("YYYY"),
  notes: "",
  company_id: null,
  payroll_date: moment().format("YYYY-MM-DD"),
  csv: null,
  csv_base64: null,
});

const createInitialCsvValidation = () => ({
  checked: false,
  isValid: false,
  message: "",
  errors: [],
});

const createInitialCsvSummary = () => ({
  totalSalary: 0,
  totalRows: 0,
});

const createInitialExistingUserSummary = () => ({
  totalSalary: 0,
  totalRows: 0,
});

export default {
  name: "CreateWpsRequest",
  props: {
    isShown: {
      type: Boolean,
      default: false,
    },
    mode: String,
    clientData: Object,
  },
  data() {
    return {
      total_rows: 0,
      loading: {
        submit: false,
        company: false,
        companyClient: false,
        setting: false,
        validate: false,
      },
      show: false,
      year_options: [
        { value: "2026", text: "2026" },
        { value: "2027", text: "2027" },
      ],
      form: createInitialForm(),
      datePickerStartOptions: {
        disabledDate: (date) => moment(date).isBefore(moment(), "days"),
      },
      companies: {
        rows: [],
        count: 0,
      },
      company_client: {
        rows: [],
        count: 0,
      },
      companyPolicy: {
        max_balance_disbursement: 0,
        total_limit_percentage: 100,
        alert_method: "",
      },
      companySettingMeta: {
        company_vendor_id: null,
        company_client_id: null,
      },
      timeoutSearchCompany: null,
      companyFilter: {
        search_keyword: "",
        per_page: 15,
      },
      recipient_from: "file",
      csvValidation: createInitialCsvValidation(),
      csvSummary: createInitialCsvSummary(),
      existingUserSummary: createInitialExistingUserSummary(),
      options: [],
    };
  },
  created() {
    for (let i = 1; i <= 12; i += 1) {
      this.options.push(String(i).padStart(2, "0"));
    }
  },
  computed: {
    isSubmitDisabled() {
      if (this.loading.submit || this.loading.validate) {
        return true;
      }

      if (this.recipient_from === "file") {
        return !this.form.csv || !this.csvValidation.checked || !this.csvValidation.isValid;
      }

      if (this.recipient_from === "existing_user") {
        if (!this.form.company_id || !this.form.id || !this.form.payroll_date) {
          return true;
        }

        if (this.total_rows <= 0) {
          return true;
        }

        return (
          this.companyPolicy.max_balance_disbursement > 0 &&
          this.existingUserSummary.totalSalary > this.companyPolicy.max_balance_disbursement
        );
      }

      return false;
    },
  },
  methods: {
    resetCsvValidation() {
      this.csvValidation = createInitialCsvValidation();
      this.csvSummary = createInitialCsvSummary();
    },
    normalizeEditForm(data = {}) {
      return {
        ...createInitialForm(),
        ...data,
        id: data.id ?? data.company_client_id ?? null,
        company_id: data.company_id ?? null,
        period_month: String(data.period_month || moment().format("MM")).padStart(2, "0"),
        period_year: String(data.period_year || moment().format("YYYY")),
        csv: null,
        csv_base64: null,
      };
    },
    async onChangeFile(event) {
      const file = event.target.files[0];
      this.resetCsvValidation();
      this.form.csv = null;
      this.form.csv_base64 = null;
      if (!file) {
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result;
        this.form.csv = file;
        this.form.csv_base64 = base64;
      };
      reader.readAsDataURL(file);
    },
    onHide() {
      this.resetForm();
      this.$emit("onHide");
    },
    async loadCompanies({ search_keyword = "" } = {}) {
      this.loading.company = true;
      try {
        await this.$store.dispatch(GET_COMPANIES, {
          per_page: this.companyFilter.per_page,
          search_keyword,
        });
        this.companies = this.$store.getters.companies;
      } finally {
        this.loading.company = false;
      }
    },
    async loadCompanyByVendor() {
      if (!this.form.company_id) {
        this.company_client = {
          rows: [],
          count: 0,
        };
        return;
      }

      this.loading.companyClient = true;
      try {
        await this.$store.dispatch(GET_COMPANY_CLIENTS_BY_VENDOR, {
          id: this.form.company_id,
        });
        this.company_client = this.$store.getters.company_clients_by_vendor;
      } finally {
        this.loading.companyClient = false;
      }
    },
    async loadCompanySetting(companyClientId) {
      if (!companyClientId) {
        this.companyPolicy = {
          max_balance_disbursement: 0,
          total_limit_percentage: 100,
          alert_method: "",
        };
        this.companySettingMeta = {
          company_vendor_id: null,
          company_client_id: null,
        };
        return;
      }

      this.loading.setting = true;
      try {
        const response = await this.$store.dispatch(GET_COMPANY_CLIENT_SETTINGS, {
          id: companyClientId,
        });
        const settingCandidates = [response?.rows?.[0], response?.data?.rows?.[0], response?.data, response].filter(Boolean);
        const settingData = settingCandidates[0] || {};
        this.companyPolicy = settingData.company_policy || {
          max_balance_disbursement: 0,
          total_limit_percentage: 100,
          alert_method: "",
        };
        this.companySettingMeta = {
          company_vendor_id: settingData.company_vendor_id || null,
          company_client_id: settingData.company_client_id || companyClientId,
        };
      } finally {
        this.loading.setting = false;
      }
    },
    async loadExistingUserSummary(companyClientId = this.form.id) {
      if (!companyClientId) {
        this.total_rows = 0;
        this.existingUserSummary = createInitialExistingUserSummary();
        return;
      }

      try {
        const response = await this.$store.dispatch(GET_COMPANY_CLIENT_EMPLOYEE_LIST, {
          id: companyClientId,
          page: 1,
          size: 10000,
          per_page: 10000,
          show_deleted: false,
        });

        const rows = Array.isArray(response?.rows) ? response.rows : [];
        const totalRows = Number(response?.count || response?.total || rows.length || 0);
        const totalSalary = rows.reduce((total, item) => total + this.sanitizeAmount(item?.salary), 0);

        this.total_rows = totalRows;
        this.existingUserSummary = {
          totalRows,
          totalSalary,
        };
      } catch (error) {
        this.total_rows = 0;
        this.existingUserSummary = createInitialExistingUserSummary();
      }
    },
    searchCompany(value) {
      clearTimeout(this.timeoutSearchCompany);
      this.timeoutSearchCompany = setTimeout(() => {
        this.companyFilter.search_keyword = value;
        this.loadCompanies({
          search_keyword: this.companyFilter.search_keyword,
        });
      }, 400);
    },
    handleSubmitSuccess(message, type = "success") {
      this.$message({
        title: type === "success" ? "Success" : "Failed",
        type,
        message,
      });
      this.resetForm();
      this.onHide();
    },
    extractBusinessCode(response) {
      return Number(response?.data?.code || response?.code || 0);
    },
    extractBusinessMessage(response, fallbackMessage) {
      return response?.data?.message || response?.message || fallbackMessage;
    },
    resetForm() {
      this.form = createInitialForm();
      this.company_client = {
        rows: [],
        count: 0,
      };
      this.companyFilter.search_keyword = "";
      this.recipient_from = "file";
      this.companyPolicy = {
        max_balance_disbursement: 0,
        total_limit_percentage: 100,
        alert_method: "",
      };
      this.companySettingMeta = {
        company_vendor_id: null,
        company_client_id: null,
      };
      this.resetCsvValidation();
      this.existingUserSummary = createInitialExistingUserSummary();
    },
    formatCurrency(value) {
      return `Rp ${Number(value || 0).toLocaleString("id-ID")}`;
    },
    sanitizeAmount(value) {
      const normalized = String(value || "").replace(/[^0-9.-]/g, "");
      if (!normalized) {
        return 0;
      }

      const numericValue = Number(normalized);
      if (Number.isNaN(numericValue)) {
        return Number.NaN;
      }

      return numericValue < 0 ? Math.ceil(numericValue) : Math.floor(numericValue);
    },
    validateBeforeSubmit() {
      if (!this.form.company_id) {
        return "Company is required.";
      }

      if (!this.form.id) {
        return "Company client is required.";
      }

      if (this.recipient_from === "file") {
        if (!this.form.csv) {
          return "CSV file is required.";
        }

        if (!this.csvValidation.isValid) {
          return this.csvValidation.checked ? "CSV format is still invalid." : "Validate CSV format before submit.";
        }

        if (
          this.companyPolicy.max_balance_disbursement > 0 &&
          this.csvSummary.totalSalary > this.companyPolicy.max_balance_disbursement
        ) {
          return "Total nominal disbursement melebihi batas kebijakan perusahaan.";
        }
      }

      if (this.recipient_from === "existing_user" && this.total_rows <= 0) {
        return "No active existing user found for this company client.";
      }

      if (
        this.recipient_from === "existing_user" &&
        this.companyPolicy.max_balance_disbursement > 0 &&
        this.existingUserSummary.totalSalary > this.companyPolicy.max_balance_disbursement
      ) {
        return "Total nominal disbursement melebihi batas kebijakan perusahaan.";
      }

      return "";
    },
    normalizeCsvHeader(value) {
      return String(value || "")
        .trim()
        .toLowerCase();
    },
    async readCsvRows() {
      if (!this.form.csv) {
        return [];
      }

      const content = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsText(this.form.csv);
        reader.onload = () => resolve(reader.result || "");
        reader.onerror = (error) => reject(error);
      });

      return String(content)
        .split(/\r?\n/g)
        .map((row) => row.trim())
        .filter((row) => row !== "");
    },
    async validateCsvFormat() {
      const requiredHeaders = ["full_name", "bank_name", "bank_account", "salary"];

      if (!this.form.csv) {
        this.csvValidation = {
          checked: true,
          isValid: false,
          message: "CSV file is required.",
          errors: [],
        };
        return;
      }

      this.loading.validate = true;
      try {
        const rows = await this.readCsvRows();

        if (!rows.length) {
          this.csvValidation = {
            checked: true,
            isValid: false,
            message: "CSV file is empty.",
            errors: [],
          };
          return;
        }

        const headers = rows[0].split(/;|,/gi).map(this.normalizeCsvHeader);
        const missingHeaders = requiredHeaders.filter((header) => !headers.includes(header));

        if (missingHeaders.length) {
          this.csvValidation = {
            checked: true,
            isValid: false,
            message: `Missing required header: ${missingHeaders.join(", ")}`,
            errors: [],
          };
          return;
        }

        const headerIndexMap = headers.reduce((accumulator, header, index) => {
          accumulator[header] = index;
          return accumulator;
        }, {});

        const errors = [];
        let totalSalary = 0;

        for (let index = 1; index < rows.length; index += 1) {
          const columns = rows[index].split(/;|,/gi).map((column) => String(column || "").trim());
          const rowNumber = index + 1;
          const fullName = columns[headerIndexMap.full_name] || "";
          const bankName = columns[headerIndexMap.bank_name] || "";
          const bankAccount = columns[headerIndexMap.bank_account] || "";
          const salary = columns[headerIndexMap.salary] || "";
          const normalizedSalary = this.sanitizeAmount(salary);

          if (!fullName || !bankName || !bankAccount || !salary) {
            errors.push({
              row: rowNumber,
              message: "full_name, bank_name, bank_account, and salary are required.",
            });
          } else if (Number.isNaN(normalizedSalary)) {
            errors.push({
              row: rowNumber,
              message: "salary must be numeric.",
            });
          } else {
            totalSalary += normalizedSalary;
          }

          if (errors.length >= 20) {
            break;
          }
        }

        if (
          errors.length === 0 &&
          this.companyPolicy.max_balance_disbursement > 0 &&
          totalSalary > this.companyPolicy.max_balance_disbursement
        ) {
          errors.push({
            row: "Summary",
            message: `Total salary ${this.formatCurrency(totalSalary)} exceeds limit ${this.formatCurrency(
              this.companyPolicy.max_balance_disbursement
            )}.`,
          });
        }

        this.csvSummary = {
          totalSalary,
          totalRows: Math.max(rows.length - 1, 0),
        };

        this.csvValidation = {
          checked: true,
          isValid: errors.length === 0,
          message:
            errors.length === 0
              ? `CSV format is valid. Total rows checked: ${Math.max(rows.length - 1, 0)}`
              : `CSV format is invalid. Showing first ${errors.length} error(s).`,
          errors,
        };
      } catch (error) {
        this.csvSummary = createInitialCsvSummary();
        this.csvValidation = {
          checked: true,
          isValid: false,
          message: "Failed to validate CSV format.",
          errors: [],
        };
      } finally {
        this.loading.validate = false;
      }
    },
    async onSubmit() {
      const isEditMode = this.mode === "edit";
      const fallbackSuccessMessage = isEditMode ? "WPS successfully updated" : "WPS successfully created";
      const validationMessage = this.validateBeforeSubmit();

      if (validationMessage) {
        this.$message({
          title: "Invalid Data",
          type: "error",
          message: validationMessage,
        });
        return;
      }

      try {
        const requestBody = {
          company_id: this.form.company_id || 0,
          company_client_id: this.form.id || 0,
          period_month: String(this.form.period_month || 0),
          period_year: this.form.period_year || 0,
          payroll_date: this.form.payroll_date || 0,
          notes: this.form.notes || null,
          source_type: this.recipient_from === "file" ? "csv" : "existing_user",
        };

        if (requestBody.source_type === "csv") {
          requestBody.csv_base64 = this.form.csv_base64 || null;
        }

        this.loading.submit = true;
        let response = null;

        if (this.mode === "create") {
          response = await this.$store.dispatch(CREATE_WPS, requestBody);
        }
        if (this.mode === "edit") {
          response = await this.$store.dispatch(UPDATE_WPS, {
            id: this.form.id,
            ...requestBody,
          });
        }

        const businessCode = this.extractBusinessCode(response);
        const successMessage = this.extractBusinessMessage(response, fallbackSuccessMessage);

        if (businessCode >= 400) {
          this.handleSubmitSuccess(successMessage, "error");
          return;
        }

        this.handleSubmitSuccess(successMessage);
      } catch (err) {
        popupErrorMessages(err.response?.data || err);
      } finally {
        this.loading.submit = false;
      }
    },
    handlerChangeCompany() {
      this.form.id = null;
      this.total_rows = 0;
      this.existingUserSummary = createInitialExistingUserSummary();
      this.companyPolicy = {
        max_balance_disbursement: 0,
        total_limit_percentage: 100,
        alert_method: "",
      };
      this.companySettingMeta = {
        company_vendor_id: null,
        company_client_id: null,
      };
      this.resetCsvValidation();
      this.loadCompanyByVendor();
    },
    handleCompanyClientChange(value) {
      this.resetCsvValidation();
      this.loadCompanySetting(value);
      if (this.recipient_from === "existing_user") {
        this.loadExistingUserSummary(value);
      } else {
        this.total_rows = 0;
        this.existingUserSummary = createInitialExistingUserSummary();
      }
    },
    recipientFromHandler(value) {
      if (value !== "file") {
        this.form.csv = null;
        this.form.csv_base64 = null;
        this.resetCsvValidation();
      }

      if (value === "existing_user") {
        this.loadExistingUserSummary();
      } else {
        this.total_rows = 0;
        this.existingUserSummary = createInitialExistingUserSummary();
      }
    },
  },
  watch: {
    isShown: {
      immediate: true,
      handler(val) {
        this.show = val;
        if (val) {
          if (this.mode === "edit" && this.clientData) {
            this.form = this.normalizeEditForm(this.clientData);
            this.loadCompanyByVendor();
            if (this.form.id) {
              this.loadCompanySetting(this.form.id);
            }
          }
          if (this.mode === "create") {
            this.resetForm();
          }
          this.loadCompanies();
        }
      },
    },
  },
};
</script>
<style>
.custom-file-label {
  font-size: 0.75rem;
}
</style>
